import React, { useState } from 'react';
import { Input, Select, Button, Tag, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { Option } = Select;

const SimNumberPicker = () => {
  const [digits, setDigits] = useState(Array(7).fill(''));
  const [filterDigit, setFilterDigit] = useState(null);
  const [format, setFormat] = useState('');

  const handleDigitChange = (value, index) => {
    const newDigits = [...digits];
    newDigits[index] = value.replace(/\D/, ''); // Chỉ cho phép số
    setDigits(newDigits);
  };

  const handleSearch = () => {
    const fullNumber = '087' + digits.join('');
    console.log('Tìm kiếm số:', fullNumber);
    console.log('Loại trừ số:', filterDigit);
    console.log('Định dạng số:', format);
    // Gọi API hoặc lọc danh sách số ở đây
  };

  return (
    <div className="bg-red-700 p-6 rounded-lg text-white">
      <h2 className="text-xl font-semibold mb-4">Nhập số thuê bao mong muốn</h2>
      <Space wrap className="mb-4">
        <span className="text-xl font-bold">087</span>
        {digits.map((digit, index) => (
          <Input
            key={index}
            value={digit}
            maxLength={1}
            style={{ width: 40, textAlign: 'center' }}
            onChange={(e) => handleDigitChange(e.target.value, index)}
          />
        ))}
        <Button
          icon={<SearchOutlined />}
          onClick={handleSearch}
          type="primary"
          style={{ backgroundColor: '#fff', color: '#d32f2f' }}
        >
          Tìm kiếm
        </Button>
      </Space>

      <div className="text-white mb-4">
        <div className="mb-2">Loại trừ số:</div>
        <Space wrap>
          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
            <Tag.CheckableTag
              key={num}
              checked={filterDigit === num}
              onChange={() => setFilterDigit(filterDigit === num ? null : num)}
            >
              {num}
            </Tag.CheckableTag>
          ))}
        </Space>
      </div>

      <div className="text-white">
        <div className="mb-2">Định dạng số:</div>
        <Select
          value={format}
          onChange={setFormat}
          style={{ width: 200 }}
          placeholder="Tất cả định dạng số"
        >
          <Option value="">Tất cả định dạng</Option>
          <Option value="camket">SIM Cam kết 49K</Option>
          <Option value="vip">VIP6/VIP12</Option>
          <Option value="thuong">SIM số thường</Option>
          <Option value="lap">SIM số lặp</Option>
        </Select>
      </div>
    </div>
  );
};

export default SimNumberPicker;
